import { useEffect, useState } from "react";
import { apiClient } from "@/context/AuthContext";
import SignaturePad from "@/components/SignaturePad";
import StampBuilder from "@/components/StampBuilder";
import { AlertTriangle, Check, Loader2, Save, UserRound, X } from "lucide-react";

export default function ProfileModal({ onClose, onToast }) {
  const [me, setMe] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { (async () => {
    try { const { data } = await apiClient.get("/auth/me"); setMe(data); }
    catch (err) { setError(err?.response?.data?.detail || "Profil yüklenemedi"); }
  })(); }, []);

  const upd = (k, v) => setMe((m) => ({ ...m, [k]: v }));

  const save = async () => {
    setSaving(true); setError("");
    try {
      const payload = {
        name: me.name, title: me.title, chamber: me.chamber,
        license_no: me.license_no, phone: me.phone,
        signature_b64: me.signature_b64 || undefined,
        stamp_b64: me.stamp_b64 || undefined,
      };
      await apiClient.patch("/auth/me", payload);
      onToast?.("Profil kaydedildi");
      onClose?.();
    } catch (err) {
      setError(err?.response?.data?.detail || "Profil kaydedilemedi");
    } finally { setSaving(false); }
  };

  if (!me) return (
    <div className="modal-backdrop" data-testid="profile-modal"><div className="modal wide-modal">Yükleniyor…</div></div>
  );

  return (
    <div className="modal-backdrop" data-testid="profile-modal">
      <div className="modal wide-modal" style={{maxWidth: 820}}>
        <div className="modal-head">
          <div><div className="eyebrow">PROFİL & İMZA KUTUSU</div><h2>{me.name}</h2></div>
          <button className="icon-button" onClick={onClose} data-testid="profile-close"><X size={17}/></button>
        </div>
        <div className="step-body">
          <div className="row-fields">
            <label>Ad Soyad<input value={me.name || ""} onChange={(e) => upd("name", e.target.value)} data-testid="profile-name"/></label>
            <label>Ünvan<input value={me.title || ""} onChange={(e) => upd("title", e.target.value)} placeholder="Örn. Yangın Danışmanı" data-testid="profile-title"/></label>
            <label>Telefon<input value={me.phone || ""} onChange={(e) => upd("phone", e.target.value)} data-testid="profile-phone"/></label>
          </div>
          <div className="row-fields">
            <label>Oda<input value={me.chamber || ""} onChange={(e) => upd("chamber", e.target.value)} placeholder="TMMOB MMO" data-testid="profile-chamber"/></label>
            <label>Sicil No<input value={me.license_no || ""} onChange={(e) => upd("license_no", e.target.value)} data-testid="profile-license"/></label>
            <label>E-posta<input value={me.email || ""} disabled/></label>
          </div>

          <div className="section-title"><div><div className="eyebrow">İMZA</div><h2 style={{fontSize:14,margin:0}}>Mouse veya parmakla çizin</h2></div></div>
          <SignaturePad value={me.signature_b64} onChange={(d) => upd("signature_b64", d)}/>

          <div className="section-title"><div><div className="eyebrow">KAŞE</div><h2 style={{fontSize:14,margin:0}}>Oda / Sicil bilgileri ile oluştur</h2></div></div>
          <StampBuilder
            initial={{
              full_name: me.name, title: me.title,
              chamber: me.chamber, license_no: me.license_no,
            }}
            onChange={(d) => upd("stamp_b64", d)}
          />

          {error && <div className="auth-error" data-testid="profile-error"><AlertTriangle size={14}/> {error}</div>}
          <div className="step-actions">
            <button type="button" className="secondary-btn" onClick={onClose}>İptal</button>
            <button type="button" className="primary-btn" onClick={save} disabled={saving} data-testid="profile-save">
              {saving ? <Loader2 size={14} className="spin"/> : <Save size={14}/>} Kaydet
            </button>
          </div>
          <small className="legal-foot"><Check size={13}/> İmza ve kaşe PDF raporuna QR'lı imza sayfası olarak eklenir.</small>
        </div>
      </div>
    </div>
  );
}
